import Component from './exterior-angle';

export default Component;